import React, { useMemo } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { ButtonSplitGroup } from '@components/Buttons';
import { BootstrapGenericTable } from '@components/Table/Table';

const renderActionCell = ({ row, dedicatedChannelsProps }) => {
  const { did, canAdd, canRemove } = row.original;
  const { add, remove } = dedicatedChannelsProps;

  return (
    <ButtonSplitGroup>
      <Button
        variant="didxl"
        size="sm"
        onClick={() => add.query(did)}
        disabled={!canAdd}
      >
        +
      </Button>
      <Button
        variant="didxl"
        size="sm"
        onClick={() => {
          remove.query(did);
        }}
        disabled={!canRemove}
      >
        -
      </Button>
    </ButtonSplitGroup>
  );
};

const renderChannelsAmountCell = ({ row, value }) => {
  const { cart_channels: cartChannels } = row.original;
  return (
    <>
      {value}{' '}
      {cartChannels ? (
        <span className="textGreen"> (+{cartChannels})</span>
      ) : null}
    </>
  );
};

const renderActionHeader = ({ dedicatedChannelsProps }) => (
  <>
    <p className="m-0">Action</p>
    <Button
      onClick={() => dedicatedChannelsProps.clear.query()}
      variant="didxl"
      size="sm"
    >
      Clear
    </Button>
  </>
);

export const DedicatedChannelsTable = ({
  useData,
  searchParams,
  dedicatedChannelsProps,
}) => {
  const navigate = useNavigate();
  const { login } = useSelector((state) => state.auth.user);
  const exportContent = () => (
    <ButtonSplitGroup>
      <Button
        variant="didxl"
        size="sm"
        onClick={() => {
          navigate('/cart/checkout');
        }}
      >
        Buy and Check-out
      </Button>
      <Button
        as={Link}
        variant="didxl"
        size="sm"
        to="/order/dedicated-channels/cancel"
      >
        Cancel channels
      </Button>
    </ButtonSplitGroup>
  );

  const country = searchParams.get('country');
  const plan = country ? searchParams.get('plan') : '';
  const did = searchParams.get('did');
  const filterData = {
    country,
    plan,
    did,
  };

  const columns = useMemo(
    () => [
      {
        id: 'did',
        Header: 'Number',
        accessor: 'did',
        className: 'col-md-1',
      },
      {
        id: 'country',
        Header: 'Country',
        accessor: 'country',
      },
      {
        id: 'profileName',
        Header: 'Profile',
        accessor: 'account',
        className: 'col-md-2',
      },
      {
        id: 'plan',
        Header: 'Plan',
        accessor: 'plan',
        className: 'col-md-1',
      },
      {
        Header: '# Ded. Chan',
        accessor: 'n_channels',
        className: 'col-md-1',
        Cell: ({ row, value }) =>
          renderChannelsAmountCell({ row, value, dedicatedChannelsProps }),
      },
      {
        Header: 'Max Ded. Chan',
        accessor: 'max_n_channels',
        className: 'col-md-1',
      },
      {
        Header: 'MRC DID',
        accessor: 'mrc_did',
        className: 'col-md-1',
      },
      {
        Header: 'MRC Chan',
        accessor: 'mrc_channels',
        className: 'col-md-1',
      },
      {
        Header: 'NRC Chan',
        accessor: 'nrc_channels',
        className: 'col-md-1',
      },
      {
        Header: () => renderActionHeader({ dedicatedChannelsProps }),
        Cell: ({ row }) =>
          renderActionCell({
            row,
            dedicatedChannelsProps,
          }),
        accessor: 'action',
        className: 'col-md-1 text-center',
      },
    ],
    [country, plan, did]
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">
        Order dedicated channels for numbers
      </Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          useData={useData}
          columns={columns}
          filterData={filterData}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          paginated
          useDataArgs={{ login }}
          exportContent={(table) => exportContent(table)}
        />
      </Card.Body>
    </Card>
  );
};
